(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-proof]:not([data-proof-ready])').forEach(section => {
      section.dataset.proofReady = 'true';
      const rail = section.querySelector('[data-proof-rail]');
      if (!rail) return;
      const cards = [...rail.querySelectorAll('[data-proof-card]')];
      const count = section.querySelector('[data-proof-count]');
      const empty = section.querySelector('[data-proof-empty]');
      const arrows = [...section.querySelectorAll('[data-proof-step]')];
      const updateArrows = () => arrows.forEach(button => {
        const atStart = rail.scrollLeft < 2;
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        button.disabled = Number(button.dataset.proofStep) < 0 ? atStart : atEnd;
      });
      section.addEventListener('click', event => {
        const filter = event.target.closest('[data-proof-filter]');
        if (filter) {
          const type = filter.dataset.proofFilter;
          let visible = 0;
          cards.forEach(card => {
            const rating = Number(card.dataset.rating);
            const show = type === 'all' || (type === 'critical' ? rating <= 3 : type === 'media' ? card.dataset.hasMedia === 'true' : rating === Number(type));
            card.hidden = !show;
            if (show) visible++;
            if (!show) card.querySelectorAll('video').forEach(video => video.pause());
          });
          section.querySelectorAll('[data-proof-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          count.textContent = visible;
          empty.hidden = visible !== 0;
          rail.hidden = visible === 0;
          rail.scrollLeft = 0;
          requestAnimationFrame(updateArrows);
        }
        const arrow = event.target.closest('[data-proof-step]');
        if (arrow) {
          const width = cards.find(card => !card.hidden)?.getBoundingClientRect().width || rail.clientWidth;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 22;
          rail.scrollBy({left: Number(arrow.dataset.proofStep) * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
      });
      rail.addEventListener('scroll', updateArrows, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(updateArrows).observe(rail);
      updateArrows();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
